<template>
  <v-dialog
    width="500"
    persistent
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card :loading="loading">
      <v-card-title>
        Cadastro de Atividade
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="name"
          :error-messages="formErrors.name"
          label="Nome"
          @input="formErrors.name = ''"
        />
        <v-text-field
          v-model="url"
          :error-messages="formErrors.url"
          label="URL"
          @input="formErrors.url = ''"
        />
        <v-text-field
          v-model="cover_path"
          :error-messages="formErrors.cover_path"
          label="URL da capa"
          @input="formErrors.cover_path = ''"
        />
        <v-text-field
          v-model="description"
          :error-messages="formErrors.description"
          label="Descrição"
          @input="formErrors.description = ''"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="primary"
          text
          @click="onCancel"
        >
          Fechar
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="save()"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'

export default {
  components: {
  },
  mixins: [
    handlesServerValidation
  ],

  data: () => ({
    name: '',
    url: '',
    cover_path: '',
    description: '',
    loading: false
  }),

  created () {
  },

  methods: {
    async save () {
      // this.loading = true

      const data = {
        name: this.name,
        url: this.url,
        cover_path: this.cover_path,
        description: this.description
      }

      try {
        const response = await this.$api.createActivities(data)
        this.onSubmit(response)
      } catch (e) {
        this.getErrors(e)
      }
      this.loading = false
    },
    onCancel () {
      this.$emit('resolve', false)
    },

    onSubmit (value) {
      this.$emit('resolve', value)
    }
  }
}
</script>
